const KEY_PATTERN = /^asl:[1-9][0-9]*$/;

export function flattenAslTree(tree = []) {
  const result = [];
  const visit = (nodes) => { for (const node of nodes || []) { result.push(node); visit(node.children); } };
  visit(tree);
  return result;
}

export function getAslNodeByKey(tree, key) {
  if (!key) return null;
  return flattenAslTree(tree).find((node) => node.key === key) || null;
}

export function getAslPathToRoot(tree, key) {
  const nodes = flattenAslTree(tree);
  const byKey = new Map(nodes.map((node) => [node.key, node]));
  const path = [];
  let node = byKey.get(key);
  while (node) { path.unshift(node); node = node.parentKey ? byKey.get(node.parentKey) : null; }
  return path;
}

export function resolveAslSlugPath(tree, slugs = []) {
  if (!Array.isArray(slugs) || !slugs.length) return null;
  let candidates = (tree || []).filter((node) => node.slug === slugs[0]);
  for (const slug of slugs.slice(1)) candidates = candidates.flatMap((node) => (node.children || []).filter((child) => child.slug === slug));
  return candidates.length === 1 ? candidates[0] : null;
}

export function getAslLevelTwoGroups(tree = []) {
  return (tree || []).map((root) => ({ ...root, groups: root.children || [] }));
}

export function parseAslCategoryQuery(query) {
  const params = query instanceof URLSearchParams ? query : new URLSearchParams(query || '');
  const values = params.getAll('aslCategory');
  if (!values.length) return { key: '', error: '' };
  if (values.length > 1) return { key: '', error: 'repeated' };
  if (!KEY_PATTERN.test(values[0])) return { key: '', error: 'invalid' };
  return { key: values[0], error: '' };
}

export function buildAslCategoryUrl(key) {
  return key ? `/catalog?aslCategory=${encodeURIComponent(key)}` : '/catalog';
}

export function isAslCategoryActive(currentPath, key, tree = []) {
  if (typeof currentPath !== 'string' || typeof key !== 'string' || !KEY_PATTERN.test(key)) return false;
  const queryStart = currentPath.indexOf('?');
  if (queryStart < 0) return false;
  const query = currentPath.slice(queryStart + 1).split('#', 1)[0];
  const parsed = parseAslCategoryQuery(new URLSearchParams(query));
  if (parsed.error || !parsed.key) return false;
  return getAslPathToRoot(tree, parsed.key).some((node) => node.key === key);
}
